<script setup lang="ts">
import type { TSortItem } from '~/layers/catalog/data/types'
import { useCatalogStore } from '~/layers/catalog/store/catalog'
import { vOnClickOutside } from '@vueuse/components'
import { useCatalogSort } from '~/layers/catalog/composables/catalogSort'
import { useCatalogGridStore } from '~/layers/catalog/store/catalogGrid'

const gridStore = useCatalogGridStore()
const store = useCatalogStore()
const filter = useCatalogFilter()

const isOpened = ref(false)

const open = () => {
  isOpened.value = true
}

const close = () => {
  isOpened.value = false
}

const toggle = () => {
  isOpened.value = !isOpened.value
}

const current = computed(() => gridStore.sorting.find((i) => i.code === store.sort.code && i.direction === store.sort.direction))

const select = (item: TSortItem) => {
  useCatalogSort().set(item.code, item.direction)
  close()
}
</script>

<template>
  <div class="catalog__top-text catalog__sort-link catalog_desktop" @click="toggle" v-on-click-outside="close">
    {{ current?.name || 'Сортировка' }}
    <svg-icon height="16" name="down-arrow" width="16" />
    <div :class="{ sort_open: isOpened }" class="sort">
      <template v-for="(item, idx) in gridStore.sorting" :key="item.code + '.' + idx">
        <label class="filters__value cursor-pointer" @click.stop="select(item)">
          <input
            name="catalogSort"
            class="radio__input"
            type="radio"
            :value="item.code"
            :checked="item.code === store.sort.code && item.direction === store.sort.direction"
          />
          <p class="radio__text">
            <template v-if="filter.isEnabledRuValues(item.code) && !!item.nameRu"> {{ item.nameRu }}</template>
            <template v-else>{{ item.name }}</template>
          </p>
        </label>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
@use '/assets/scss/components/sort.scss' as *;
</style>
